export class Answer {
  content!: string
}